import React from 'react'
import { func } from 'prop-types'

import HeadEditor from './HeadEditor'
import ItemsEditor from './ItemsEditor'
import Print from './Print'

import style from './style'

function PurchaseOrderEditor (props) {
  const {
    saveEditing,
    cancelEditing,
    printOrder,
    spliter,
    ...rest,
  } = props
  return (
    <div>
      <div className={style.screen}>
        <h3 className={style.pageTitle}>進貨單</h3>
        <HeadEditor {...{ spliter, ...rest }} style={style} />
        <ItemsEditor {...spliter(props)('items')} limit={14} style={style} />
        <div className={style['button-container']}>
          <button className="btn btn-primary btn-lg" onClick={saveEditing} >儲存</button>
          <button className="btn btn-default btn-lg" onClick={cancelEditing} >取消</button>
          <button className="btn btn-info btn-lg" onClick={printOrder} >列印</button>
        </div>
      </div>
      <Print style={style} {...rest} />
    </div>
  )
}

PurchaseOrderEditor.propTypes = {
  saveEditing: func.isRequired,
  cancelEditing: func.isRequired,
  printOrder: func.isRequired,
  spliter: func.isRequired,
}

export default PurchaseOrderEditor



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor/Editor.jsx